/* LMS Pricing — billing toggle + animated hero stage.
   Toggle uses CSS [data-show-on] sibling reveal for prices/sub/overage,
   so this JS only positions the sliding pill, swaps the active button,
   updates CTA hrefs, and persists the choice in localStorage. */

(function () {
  const root = document.querySelector('[data-lms-pricing]');
  if (!root) return;

  const toggle = root.querySelector('.toggle');
  const btnMonth = root.querySelector('[data-interval="month"]');
  const btnYear = root.querySelector('[data-interval="year"]');
  const pill = root.querySelector('.toggle .pill');
  if (!toggle || !btnMonth || !btnYear || !pill) return;

  let interval = 'year';
  try {
    const saved = localStorage.getItem('xl_interval');
    if (saved === 'month' || saved === 'year') interval = saved;
  } catch (e) {}

  function positionPill() {
    const target = interval === 'month' ? btnMonth : btnYear;
    pill.style.width = target.offsetWidth + 'px';
    pill.style.left = target.offsetLeft + 'px';
  }

  function apply() {
    root.dataset.interval = interval;
    btnMonth.classList.toggle('active', interval === 'month');
    btnYear.classList.toggle('active', interval === 'year');
    btnMonth.setAttribute('aria-selected', interval === 'month' ? 'true' : 'false');
    btnYear.setAttribute('aria-selected', interval === 'year' ? 'true' : 'false');

    root.querySelectorAll('[data-href-monthly]').forEach((a) => {
      a.href = interval === 'month' ? a.dataset.hrefMonthly : a.dataset.hrefAnnual;
    });

    positionPill();

    try { localStorage.setItem('xl_interval', interval); } catch (e) {}
  }

  requestAnimationFrame(() => {
    apply();
    requestAnimationFrame(() => toggle.classList.add('ready'));
  });

  btnMonth.addEventListener('click', () => { interval = 'month'; apply(); });
  btnYear.addEventListener('click', () => { interval = 'year'; apply(); });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(positionPill, 100);
  });

  // Hero image cross-fade — alternate hg-1 and hg-2 every 5s
  const hg1 = root.querySelector('.hg.hg-1');
  const hg2 = root.querySelector('.hg.hg-2');
  if (hg1 && hg2 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let active = 1;
    setInterval(() => {
      active = active === 1 ? 2 : 1;
      hg1.classList.toggle('is-active', active === 1);
      hg2.classList.toggle('is-active', active === 2);
    }, 5000);
  }
})();
